import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { StaticDependenciesService } from '../services';

type Descriptor = TypedPropertyDescriptor<(...args: any[]) => Observable<any>>;

export function HttpError(errorCodes: Record<string, string> = null): (target: object, propertyKey: string, descriptor: Descriptor) => Descriptor {

  return (target: object, propertyKey: string, descriptor: Descriptor): Descriptor => {

    const originalMethod: (...args: any[]) => Observable<any> = descriptor.value;

    descriptor.value = function(...args: any[]): Observable<any> {

      const methodStringed = originalMethod.toString();
      const pattern = new RegExp('\\b' + propertyKey + '\\b\\((.*)\\)', 'gi');

      let match = methodStringed.match(pattern)[0] ?? '';

      match = match
        .replace(propertyKey + '(', '')
        .replace(')', '')
        .replaceAll(' ', '');

      const params = match.split(',').map((param, index) => {
        return {
          param,
          value: args[index]
        };
      });

      return originalMethod.call(this, ...args).pipe(
        catchError(error => {
          const fromApi = (error?.Message || error?.message || '').toString().trim();
          let errorMessage = fromApi && !fromApi.startsWith('Http failure')
            ? fromApi
            : (errorCodes ? errorCodes[error?.InternalCode] : null);

          if (!errorMessage) {
            errorMessage = 'Problem bei der Bedienung, bitte versuchen Sie es erneut';
            console.error(
              `HTTP error in ${target.constructor.name}.${propertyKey}`,
              error,
              params
            );
          }

          StaticDependenciesService.notificationService.pushError('Fehler', errorMessage);

          return throwError(error);
        })
      );
    };

    return descriptor;
  };
}
